import { render, staticRenderFns } from "./BpDefinitionBuilder.vue?vue&type=template&id=6c280d35&"
import script from "./BpDefinitionBuilder.vue?vue&type=script&lang=js&"
export * from "./BpDefinitionBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports